import { Widget } from '@ecocart/entities';

export const getInitialValues = (): Widget => {
  const widget = new Widget();
  widget.name = 'Promo Widget';
  widget.template = 'promo';
  return widget;
};
